import React from "react";
import { string } from "prop-types";
import { Row } from "simple-flexbox";
import { StyleSheet, css } from "aphrodite";

function DetailSubTitleComponent(props) {
    const { title, mandatory, error, message, isEdit } = props;
    return (
        <>
            <Row>
                <span className={css(styles.detailTitle)}> {title}{mandatory && <span style={{color: "red"}}>*</span>} </span>

            </Row>
            {message && isEdit && <small style={{color: "#495057"}}>{message}</small>}
            {mandatory && error && <small style={{color: "red"}}>{`${title} wajib diisi`}</small>}
        </>
    )
}

DetailSubTitleComponent.propTypes = {
    title: string,
};

const styles = StyleSheet.create({
    detailTitle: {
        textAlign: "center",
        fontSize: 18,
        fontWeight: "semibold",
        color: "#2C2C2C",
        margin: "20px 0 10px 0"
    },
});

export default DetailSubTitleComponent;